import { UserPagedCollectionParams } from '@tmx/data-access';

import { FilterAssetsSelectOption } from '../features/assets/components/filter-assets-dropdown/models/filter-assets-select-option';
import { assetFilterReferenceDateTypeLookup } from '../models/asset-filter-reference-date-type';

/**
 * Manipulate a UserPagedCollectionParams object using a passed in FilterAssetsSelectOption
 * @param params UserPagedCollectionParams to set
 * @param filterAssetsSelectOption FilterAssetsSelectOption to derive from
 */
export function setFilterOptions(
  params: UserPagedCollectionParams,
  filterAssetsSelectOption: FilterAssetsSelectOption | null
) {
  if (filterAssetsSelectOption !== null) {
    switch (filterAssetsSelectOption.type) {
      case 'assetFilterReferenceDate': {
        const { referenceDateType, referenceDate } =
          filterAssetsSelectOption.value;
        const assetFilter =
          assetFilterReferenceDateTypeLookup.get(referenceDateType);
        if (typeof assetFilter === 'number') {
          params.assetFilter = assetFilter;
          params.assetFilterReferenceDate = referenceDate;
        }
        break;
      }
      case 'assignedOnly':
        params.assignedOnly = filterAssetsSelectOption.value;
        break;
      case 'copilotVersion': {
        params.copilotVersion = filterAssetsSelectOption.value;
        break;
      }
      case 'lastActiveDate': {
        params.lastActiveDateFilter = filterAssetsSelectOption.value;
        break;
      }
      case 'mapDataVersion': {
        params.mapDataVersion = filterAssetsSelectOption.value;
        break;
      }
      case 'productId': {
        params.productId = filterAssetsSelectOption.value;
        break;
      }
      case 'productLastActiveStatus': {
        params.productLastActiveStatus = filterAssetsSelectOption.value;
        break;
      }
      case 'uploadedAssets': {
        // Handled by Import Component
        break;
      }
      case 'userStatus': {
        params.userStatus = filterAssetsSelectOption.value;
        break;
      }
      // no default
    }
  }
}
